import { Turbo } from "@hotwired/turbo-rails";

// Custom Turbo Stream action: <turbo-stream action="reload_frame" target="frame-id"></turbo-stream>
// Re-fetches the src of the target turbo-frame. Useful to refresh sibling
// frames after a successful action triggered from inside a modal.
Turbo.StreamActions.reload_frame = function () {
  const frame = document.getElementById(this.target);
  if (!frame) return;

  if (typeof frame.reload === "function") {
    frame.reload();
    return;
  }

  const src = frame.getAttribute("src");
  if (!src) return;

  frame.removeAttribute("src");
  frame.setAttribute("src", src);
};

// Custom Turbo Stream action: <turbo-stream action="reload_page"></turbo-stream>
// Triggers a full page revisit via Turbo. Use it after actions that mutate
// list content on pages whose lists are not wrapped in a named turbo-frame.
Turbo.StreamActions.reload_page = function () {
  Turbo.visit(window.location.href, { action: "replace" });
};
